/**
 * Helper: Lazysizes
 * ------------------------------------------------------------------------------
 * Loosely coupled scripts for responsive and lazy loading images.
 *
 * @namespace lazysizes
 */
import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/lazysizes.js